import LegalPage from "./LegalPage";
import SECTIONS from "./impressumContent";

export default function Impressum() {
  return (
    <LegalPage
      title="Impressum"
      docTitle="Impressum — BurmeseHub"
      dateLabel="Last Updated"
      date="October 23, 2026"
      sections={SECTIONS}
      testPrefix="impressum"
    />
  );
}
